import { Button } from '@newfront-insurance/core-ui/v2';
import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';

export function SettingsDetailHeader({
  parentLabel,
  title,
  onBack,
  actions,
}: {
  parentLabel: string;
  title: string;
  onBack: () => void;
  actions?: ReactNode;
}) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0 flex-1">
        <Button
          type="button"
          variant="transparent"
          className="text-steel-400 hover:text-steel-500 h-auto max-w-full min-w-0 gap-2 p-0 font-normal"
          onClick={onBack}
          aria-label={`Back to ${parentLabel.toLowerCase()}`}
        >
          <ArrowLeft aria-hidden="true" className="size-4 shrink-0" />
          <span className="truncate">
            <span>{parentLabel}</span>
            <span className="text-steel-300 px-1">/</span>
            <span className="text-steel-500 font-semibold">{title}</span>
          </span>
        </Button>
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </header>
  );
}
